var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 20,
    viewBox: "0 0 32 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2516_5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.7012 9.14C27.5277 3.89333 21.95 1 16 1C10.05 1 4.47229 3.89333 0.298806 9.14C-0.099602 9.64 -0.099602 10.3533 0.298806 10.8533C4.47229 16.1067 10.05 19 16 19C21.95 19 27.5277 16.1067 31.7012 10.86C32.0996 10.36 32.0996 9.64 31.7012 9.14V9.14ZM16 14.46C13.59 14.46 11.6306 12.46 11.6306 10C11.6306 7.54 13.59 5.54 16 5.54C18.41 5.54 20.3694 7.54 20.3694 10C20.3694 12.46 18.41 14.46 16 14.46ZM3.08113 10C5.54995 7.18667 8.49556 5.26 11.6698 4.34C10.0239 5.65333 8.95928 7.7 8.95928 10C8.95928 12.2933 10.0173 14.34 11.6698 15.66C8.49556 14.74 5.55649 12.8133 3.08113 10ZM20.3302 15.66C21.9761 14.3467 23.0407 12.3 23.0407 10C23.0407 7.70667 21.9827 5.66 20.3302 4.34C23.5044 5.26 26.45 7.18667 28.9189 10C26.4435 12.8133 23.5044 14.74 20.3302 15.66Z",
    fill: "#BDCAD5"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2516_5"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "res/media/eye.09b3ac89d75f017cfed3fcaf70a41198.svg";
export { ForwardRef as ReactComponent };